import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GroupMode } from '../../services/document-intake.service';

export interface MultipagePromptData {
	fileName: string;
	pageCount: number;
}

export interface MultipagePromptResult {
	mode: GroupMode;
	remember: boolean;
}

/**
 * Asks how to treat a multi-page PDF: one credit memo, or one memo per page.
 * Mirrors BizSys.DocumentApp's multi-page prompt, including the remember-my-choice option.
 */
@Component({
	selector: 'app-multipage-prompt',
	templateUrl: './multipage-prompt.component.html',
	styleUrls: ['./multipage-prompt.component.scss']
})
export class MultipagePromptComponent {
	remember = false;

	constructor(
		public dialogRef: MatDialogRef<MultipagePromptComponent>,
		@Inject(MAT_DIALOG_DATA) public data: MultipagePromptData,
	) {}

	choose(mode: GroupMode): void {
		this.dialogRef.close({ mode, remember: this.remember } as MultipagePromptResult);
	}

	cancel(): void {
		this.dialogRef.close(null);
	}
}
